<template>
  <div class="contarner" >
    <div class="tip" >
      <p class="title" >产品优势</p>
      <p class="content" >更敏捷、更安全、更低成本、可持续升级</p>
    </div>
    <div class="boxs" >
      <div class="box" >
        <img class="img" src="./safe.png" alt="" v-zoomIn >
        <p class="title" >安全性</p>
        <span class="text" >数据安全、网络安全、验证安全、可用性、备份安全、多重安全保障</span>
      </div>
      <div class="box" >
        <img class="img" src="./stable.png" alt="" v-zoomIn >
        <p class="title" >稳定性</p>
        <span class="text" >采用主流的互联网微服务构架，平台各个产品线高度稳定整合</span>
      </div>
      <div class="box" >
        <img class="img" src="./expand.png" alt="" v-zoomIn >
        <p class="title" >拓展性</p>
        <span class="text" >高内聚、低耦合、标准API接口，循序渐进打造企业数字化平台</span>
      </div>
      <div class="box" >
        <img class="img" src="./muve.png" alt="" v-zoomIn >
        <p class="title" >移动化</p>
        <span class="text" >轻量级部署，支持 IOS、Android 系统，PC、手机、PAD 多终端协同</span>
      </div>
      <div class="box" >
        <img class="img" src="./par.png" alt="" v-zoomIn >
        <p class="title" >参数化</p>
        <span class="text" >弹性的企业级参数设置，更稳定、更灵活的支撑客户特性配置</span>
      </div>
      <div class="box" >
        <img class="img" src="./chosed.png" alt="" v-zoomIn >
        <p class="title" >闭环化</p>
        <span class="text" >管理过程中，形成有规划、有检查、有反馈、有改善的良性模式</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  methods: {

  }
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.contarner {
  background-color: #F0F0F0;
  padding: 40px 0;
  margin: 0 auto;
  overflow: hidden;

  .tip {
    text-align: center;

    .title {
      font-size: 25px;
      font-weight: 500;
    }

    .content {
      font-size: 15px;
      color: #666;
      margin-bottom: 30px;
    }
    @media screen and (max-width: 500px){
      .title {
        font-size: 18px;
      }

      .content {
        font-size: 12px;
      }
    }
  }

  .boxs {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 50px auto 0 auto;
    width: 80%;
    max-width: 1000px;

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      width: 30%;
      margin-bottom: 50px;
      box-sizing: border-box;

      &:last-child {
        margin-bottom: 0;
      }

      .img {
        height: 100px;
        width: 100px;
      }

      .text {
        color: #999;
      }
    }

    @media screen and (max-width: 750px) {
      .box {
        width: 50%;
        font-size: 14px;

        .img {
          height: 60px;
          width: 60px;
        }
        
        .text {
          font-size: 12px;
          padding: 0 10px;
        }
      }
    }
  }

}
</style>
